// extracted by mini-css-extract-plugin
export default {"info":"index_info__BxOsR","container":"index_container__vYEag","headertext":"index_headertext__giRem","formtext":"index_formtext__o5WPU","searchfields":"index_searchfields__ASntY"};